module.exports = __webpack_public_path__ + "static/media/xing.ef782aa1.svg";